import * as types from './types'

export const SetAccessToken = ({ commit }, data) => {
  commit(types.SET_ACCESS_TOKEN, data)
}

export const setAppInfo = ({ commit }, data) => {
  commit(types.SET_APP_INFO, data)
}
